import React from 'react';

const HomePage = ({ onNavigateToLogin }) => (
  <div style={{ minHeight: '100vh', background: 'var(--color-bg-alt)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <div style={{ background: 'var(--color-surface)', borderRadius: 'var(--border-radius)', boxShadow: 'var(--box-shadow)', padding: 'var(--card-padding)', maxWidth: 400, width: '100%', textAlign: 'center' }}>
      <h1 style={{ color: 'var(--color-primary)' }}>Welcome to Your New Website</h1>
      <p style={{ color: 'var(--color-text-light)', margin: '1rem 0' }}>
        This is a clean, modern starter using your theme system. Edit <code>theme.css</code> to change colors sitewide.
      </p>
      <button style={{
        background: 'var(--color-primary)',
        color: 'var(--color-text-inverse)',
        border: 'none',
        borderRadius: 'var(--border-radius)',
        padding: '0.75rem 1.5rem',
        fontSize: '1rem',
        cursor: 'pointer',
        marginTop: '1rem',
        boxShadow: 'var(--box-shadow)'
      }} onClick={onNavigateToLogin}>
        Login
      </button>
    </div>
  </div>
);

export default HomePage; 